angular.module('bmsApp.directives')
	.directive('smCleaningList', [
		'$q',
		'notify',
		'SMCleaningServiceSvc',
		'TaxHelperSvc',
		'AppSettingsSvc',
		'ComplaintSvc',
		function ($q,
				  notify,
				  SMCleaningServiceSvc,
				  TaxHelperSvc,
				  AppSettingsSvc,
				  ComplaintSvc) {

			function getDiscountedNet(jobCleaningService) {
				return SMCleaningServiceSvc.calcDiscountedNet(jobCleaningService);
			}

			function getDiscountedVat(jobCleaningService) {
				return SMCleaningServiceSvc.calcDiscountedVat(jobCleaningService);
			}

			function getDiscountedGross(jobCleaningService) {
				return SMCleaningServiceSvc.calcDiscountedGross(jobCleaningService);
			}

			return {
				restrict: 'E',
				transclude: true,
				scope: {
					ngModel: '=',
					quote: '=',
					disableEdit: '=',
					editFn: '&',
					deleteFn: '&',
					showMaterialTestLink: '=',
					materialTestFn: '&',
					undoDeleteFn: '&',
					allowToggle: '=',
				},
				replace: true,
				templateUrl: 'ng/sm/directives/cleaningServicesList/CleaningServicesList.html',
				link: function (scope, element, attr) {

					AppSettingsSvc.index()
						.then(function (response) {
							scope.minJobValue = parseFloat(response.data.settings.min_job_value) || 0;
						}, function (error) {
							$scope.errors = error;
						});

					scope.discountServiceCompareFn = function (obj1, obj2) {
						return obj1 === obj2;
					};

					function showDiscountFields() {
						resetTmpDiscounts();
						scope.showDiscountFields = true;
					}

					function hideDiscountFields() {
						resetTmpDiscounts();
						scope.showDiscountFields = false;
					}

					function showJobDiscountFields() {
						// resetJobTmpDiscounts();
						scope.showJobDiscountFields = true;
					}

					function hideJobDiscountFields() {
						// resetJobTmpDiscounts();
						scope.showJobDiscountFields = false;
					}

					function validateDiscounts() {
						var deferred = $q.defer();
						var invalidCount = 0;
						angular.forEach(scope.tmpDiscounts.selectedServices, function (service) {
							// if discounted gross is less than zero then it's invalid
							var tmpService = angular.copy(service);
							angular.extend(tmpService, scope.tmpDiscounts.attributes);
							if (getDiscountedGross(tmpService) < 0) {
								invalidCount++;
							}
						});

						if (invalidCount === 0) {
							deferred.resolve();
						}
						else {
							deferred.reject();
						}

						return deferred.promise;
					}

					function applyTmpDiscounts() {
						validateDiscounts()
							.then(function () {
								angular.forEach(scope.tmpDiscounts.selectedServices, function (service) {
									angular.extend(service, angular.copy(scope.tmpDiscounts.attributes));
								});
							}, function () {
								notify({
									message: 'One or more discounts exceeds cleaning service value - no discounts have been applied',
									classes: 'error',
									duration: '10000'
								});
							})
							.finally(function () {
								resetTmpDiscounts();
								scope.showDiscountFields = false;
							});
					}

					function applyJobDiscounts() {
						recalculateTotals();
						hideJobDiscountFields();
					}

					function resetTmpDiscounts() {
						scope.tmpDiscounts = {
							selectedServices: [],
							attributes: {
								discount_type: null,
								discount_value: 0,
								discount_description: ''
							}
						};
					}



					scope.loading = true;
					scope.showDiscountFields = false;
					scope.showJobDiscountFields = false;
					resetTmpDiscounts();
					$q.all({
						discountTypeOptions: SMCleaningServiceSvc.discountType.options()
							.then(function (response) {
								scope.discountTypeOptions = response.data.options;
							}),
						setVatRate: TaxHelperSvc.setVatRate()
					})
						.then(function () {
							scope.loading = false;
						});


					function recalculateTotals() {
						if (angular.isObject(scope.quote) && angular.isObject(scope.quote.discount_type)) {
							scope.totalDiscountedGross = parseFloat(scope.totalGross);
							scope.totalDiscountedNet = 0;
							scope.totalDiscountedVat = 0;
							if (scope.quote.discount_type.value === 'percent') {
								let discount = scope.quote.discount_value;
								scope.totalDiscountedGross -= scope.totalDiscountedGross * (parseFloat(discount) || 0) / 100;
							}
							else if (scope.quote.discount_type.value === 'flat') {
								let discount = scope.quote.discount_value;
								scope.totalDiscountedGross -= parseFloat(discount) || 0;
							}
							scope.totalDiscountedNet = TaxHelperSvc.netFromGross(scope.totalDiscountedGross);
							scope.totalDiscountedVat = TaxHelperSvc.vatFromGross(scope.totalDiscountedGross);

						}
						else {
							scope.totalDiscountedGross = scope.totalGross;
							scope.totalDiscountedNet = scope.totalNet;
							scope.totalDiscountedVat = scope.totalVat;
						}

						if (scope.minJobValue > scope.totalDiscountedGross) {
							scope.belowMinJobValueWarning = true;
						}
						else {
							scope.belowMinJobValueWarning = false;
						}
					}

					function viewComplaint(complaint){
						ComplaintSvc.showSaveModal(complaint, true);

					}

					scope.$watch(function () {
						return scope.ngModel;
					}, function (newVal) {
						scope.totalNet = scope.totalVat = scope.totalGross = 0;
						scope.showTotals = false;
						if (angular.isArray(newVal)) {
							angular.forEach(newVal, function (cleaningService) {
								if (!cleaningService.delete && cleaningService.accepted) {
									scope.showTotals = true;
									scope.totalNet += getDiscountedNet(cleaningService) || 0;
									scope.totalVat += getDiscountedVat(cleaningService) || 0;
									scope.totalGross += getDiscountedGross(cleaningService) || 0;
								}
							});
							recalculateTotals();
						}
						scope.methods = {
							getDiscountedNet: getDiscountedNet,
							getDiscountedVat: getDiscountedVat,
							getDiscountedGross: getDiscountedGross,
							showDiscountFields: showDiscountFields,
							hideDiscountFields: hideDiscountFields,
							showJobDiscountFields: showJobDiscountFields,
							hideJobDiscountFields: hideJobDiscountFields,
							applyTmpDiscounts: applyTmpDiscounts,
							applyJobDiscounts: applyJobDiscounts,
							viewComplaint: viewComplaint,
						};
					}, true);
				}
			};
		}
	]);
